import { createContext } from 'react'

const HppContext = createContext(null)

export default HppContext
